import { render } from "./QuizDisplay.vue?vue&type=template&id=1a9dcf5a&scoped=true"
import script from "./QuizDisplay.vue?vue&type=script&lang=js"
export * from "./QuizDisplay.vue?vue&type=script&lang=js"

import "./QuizDisplay.vue?vue&type=style&index=0&id=1a9dcf5a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9dcf5a"]])

export default __exports__